import { motion } from 'motion/react';

export function AnimatedCompass({ className }: { className?: string }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <motion.circle
        cx="12"
        cy="12"
        r="10"
        variants={{
          normal: { pathLength: 1 },
          hover: { 
            pathLength: [1, 0.8, 1],
            transition: { duration: 1.5, ease: "easeInOut", repeat: Infinity } 
          }
        }}
      />
      <motion.polygon
        points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
        variants={{
          normal: { rotate: 0, scale: 1 },
          hover: { 
            rotate: [0, 90, 180, 270, 360],
            scale: [1, 1.1, 1, 1.1, 1],
            transition: { duration: 3, ease: "linear", repeat: Infinity } 
          }
        }}
        style={{ transformOrigin: "12px 12px" }}
      />
    </motion.svg>
  );
}
